import axios from 'axios';

const setAuthToken = (token) => {
  if (token) {
    // Some callers pass the raw JWT. Ensure we use Bearer scheme which server expects.
    const headerVal = typeof token === 'string' && !token.startsWith('Bearer ') ? `Bearer ${token}` : token;
    // Apply authorization token to every request if logged in
    axios.defaults.headers.common['Authorization'] = headerVal;
  } else {
    // Delete auth header
    delete axios.defaults.headers.common['Authorization'];
  }
};

export default setAuthToken;
